import SearchCriteria from "../model/SearchCriteria";

function loadSearchCriteria(): SearchCriteria {
  let searchCriteria = new SearchCriteria("");

  try {
    // load previously saved search criteria (if any available)
    let savedSearchCriteria = localStorage.getItem("search_criteria");

    if (savedSearchCriteria) {
      searchCriteria = JSON.parse(savedSearchCriteria);
    }

    // make sure that saved search criteria is not older than 10 minutes
    const timeReference = new Date().getTime() - 10 * 60 * 1000;
    if (searchCriteria?.last_update < timeReference) {
      searchCriteria = new SearchCriteria("");
    }
  } catch (ex) {}

  return searchCriteria;
}

export default loadSearchCriteria;
